import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, delay } from 'rxjs';
import { OrderSourceModel, OrderSourceSearchParams, OrderSourceResponse, OrderSourceActionResponse } from './order-source.model';

@Injectable({
  providedIn: 'root'
})
export class OrderSourceService {
  // private http = inject(HttpClient);

  // Mock data for demonstration
  private mockOrders: OrderSourceModel[] = [
    {
      id: '1',
      thirdPartyOrderNumber: '240802-480373696852524',
      internalOrderNumber: 'CO00000006',
      sourceOrderNumber: '172292576216209bee64a',
      productLineCount: 1,
      sourceStatus: 'Source Cancelled',
      sourceSuccess: 0,
      sourceFailed: 0,
      failureReason: '',
      salesStore: 'Happy Selection Online Store',
      salesChannel: 'Shopee',
      thirdPartyOrderTime: '2024-08-02 09:12:26',
      paymentTime: '2024-08-02 09:12:33',
      sourceCreationTime: '2024-08-06 14:29:22'
    },
    {
      id: '2',
      thirdPartyOrderNumber: 'OD202511250001',
      internalOrderNumber: 'CO00000017',
      sourceOrderNumber: '172292576216209bee64b',
      productLineCount: 4,
      sourceStatus: 'Source Success',
      sourceSuccess: 4,
      sourceFailed: 0,
      failureReason: '',
      salesStore: 'Trend Station',
      salesChannel: 'Shopee',
      thirdPartyOrderTime: '2025-05-06 00:00:00',
      paymentTime: '2025-05-07 09:07:55',
      sourceCreationTime: '2025-05-08 10:15:30'
    },
    {
      id: '3',
      thirdPartyOrderNumber: 'test1112',
      internalOrderNumber: 'CO00000052',
      sourceOrderNumber: '172292576216209bee64c',
      productLineCount: 2,
      sourceStatus: 'Source Failed',
      sourceSuccess: 0,
      sourceFailed: 2,
      failureReason: 'Insufficient inventory',
      salesStore: 'Happy Selection Online Store',
      salesChannel: 'Shopee',
      thirdPartyOrderTime: '2025-04-01 00:00:00',
      paymentTime: '2025-04-02 16:08:39',
      sourceCreationTime: '2025-04-03 09:20:15'
    },
    {
      id: '4',
      thirdPartyOrderNumber: 'test111',
      internalOrderNumber: 'CO00000047',
      sourceOrderNumber: '172292576216209bee64d',
      productLineCount: 1,
      sourceStatus: 'Pending Source',
      sourceSuccess: 0,
      sourceFailed: 0,
      failureReason: '',
      salesStore: 'Happy Selection Online Store',
      salesChannel: 'Shopee',
      thirdPartyOrderTime: '2025-04-01 00:00:00',
      paymentTime: '2025-04-02 16:07:14',
      sourceCreationTime: '2025-04-03 08:45:22'
    },
    {
      id: '5',
      thirdPartyOrderNumber: '454554',
      internalOrderNumber: 'CO00000037',
      sourceOrderNumber: '172292576216209bee64e',
      productLineCount: 2,
      sourceStatus: 'Source Success',
      sourceSuccess: 2,
      sourceFailed: 0,
      failureReason: '',
      salesStore: 'Trend Station',
      salesChannel: 'Shopee',
      thirdPartyOrderTime: '2025-03-01 00:00:00',
      paymentTime: '2025-03-23 22:26:39',
      sourceCreationTime: '2025-03-24 11:30:45'
    }
  ];

  getOrders(params: OrderSourceSearchParams): Observable<OrderSourceResponse> {
    // Simulate API delay
    return of({
      data: this.mockOrders,
      total: this.mockOrders.length,
      success: true,
      message: 'Orders retrieved successfully'
    });
  }

  reSource(orderIds: string[]): Observable<OrderSourceActionResponse> {
    // Simulate API call for re-sourcing
    return of({
      success: true,
      message: `Re-source initiated for ${orderIds.length} orders`,
      affectedCount: orderIds.length
    }).pipe(delay(1000));
  }

  specifyShipment(orderIds: string[]): Observable<OrderSourceActionResponse> {
    // Simulate API call for specifying shipment
    return of({
      success: true,
      message: `Shipment specification initiated for ${orderIds.length} orders`,
      affectedCount: orderIds.length
    }).pipe(delay(1000));
  }

  exportOrders(params: OrderSourceSearchParams): Observable<string> {
    // Simulate CSV export
    const headers = [
      'Third Party Order Number',
      'Internal Order Number',
      'Source Order Number',
      'Product Line Count',
      'Source Status',
      'Source Success',
      'Source Failed',
      'Failure Reason',
      'Sales Store',
      'Sales Channel',
      'Third Party Order Time',
      'Payment Time',
      'Source Creation Time'
    ];

    const rows = this.mockOrders.map(order => [
      order.thirdPartyOrderNumber,
      order.internalOrderNumber,
      order.sourceOrderNumber,
      order.productLineCount.toString(),
      order.sourceStatus,
      order.sourceSuccess.toString(),
      order.sourceFailed.toString(),
      order.failureReason,
      order.salesStore,
      order.salesChannel,
      order.thirdPartyOrderTime,
      order.paymentTime,
      order.sourceCreationTime
    ]);

    const csvContent = [headers, ...rows]
      .map(row => row.map(cell => `"${cell}"`).join(','))
      .join('\n');

    return of(csvContent).pipe(delay(500));
  }
} 